import { Link } from 'react-router-dom';
import { getHotArticles } from '@/mocks/articles';

export default function HotNewsBar() {
  const hotArticles = getHotArticles();

  return (
    <section id="hot-news" className="w-full bg-background-100 border-b border-background-200/70">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-center gap-3 h-12">
          <span className="flex items-center gap-1.5 text-sm font-semibold text-primary-500 whitespace-nowrap font-label">
            <i className="ri-fire-line"></i>
            热点快讯
          </span>
          <div className="flex-1 overflow-hidden relative">
            <div className="flex items-center gap-6 animate-marquee whitespace-nowrap">
              {hotArticles.map((article) => (
                <Link
                  key={article.id}
                  to={`/article/${article.slug}`}
                  className="text-sm text-foreground-700 hover:text-primary-500 transition-colors cursor-pointer"
                >
                  {article.title}
                </Link>
              ))}
              {hotArticles.map((article) => (
                <Link
                  key={`dup-${article.id}`}
                  to={`/article/${article.slug}`}
                  className="text-sm text-foreground-700 hover:text-primary-500 transition-colors cursor-pointer"
                  aria-hidden="true"
                >
                  {article.title}
                </Link>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}